import { defineStore } from 'pinia'
import axios from '../axios.js'

export const useGamesNotificationStore = defineStore('gamesNotification', {
  state: () => ({
    games: [],
    showOverlay: false,
    unreadCount: 0,
    lastUpdate: null
  }),

  getters: {
    hasNewGames: (state) => state.unreadCount > 0,
    gamesWithStatus: (state) => {
      // This will be populated with database status when overlay is opened
      return state.games.map(game => ({
        ...game,
        inDatabase: game.inDatabase || false,
        rowCount: game.rowCount || 0
      }))
    }
  },

  actions: {
    addGames(newGames) {
      // Add new games to the list
      const existingGameIds = new Set(this.games.map(g => g.gameId))
      const uniqueNewGames = newGames.filter(g => !existingGameIds.has(g.gameId))
      
      this.games = [...uniqueNewGames, ...this.games]
      this.unreadCount += uniqueNewGames.length
      this.lastUpdate = new Date().toISOString()
    },

    async fetchGameStatuses(gameIds) {
      try {
        // Fetch database status for games
        const response = await axios.post('/api/games/check-status', {
          game_ids: gameIds
        })
        
        // Update games with status information
        if (response.data && response.data.statuses) {
          this.games = this.games.map(game => {
            const status = response.data.statuses[game.gameId]
            if (status) {
              return {
                ...game,
                inDatabase: status.exists && status.count > 0,
                rowCount: status.count || 0
              }
            }
            return game
          })
        }
      } catch (error) {
        console.error('Error fetching game statuses:', error)
      }
    },

    openOverlay() {
      this.showOverlay = true
      // Fetch statuses when overlay opens
      const gameIds = this.games.map(g => g.gameId).filter(Boolean)
      if (gameIds.length > 0) {
        this.fetchGameStatuses(gameIds)
      }
    },

    closeOverlay() {
      this.showOverlay = false
      // Don't mark all as read automatically - let user control this
    },

    markAsRead(gameId) {
      const game = this.games.find(g => g.gameId === gameId)
      if (game && !game.read) {
        game.read = true
        this.unreadCount = Math.max(0, this.unreadCount - 1)
      }
    },

    markAllAsRead() {
      this.games.forEach(game => {
        game.read = true
      })
      this.unreadCount = 0
    },

    clearGames() {
      this.games = []
      this.unreadCount = 0
      this.lastUpdate = null
    }
  }
})
